import { Alert, Box, List, Stack, Typography } from "@mui/material"
import { GroupType } from "authoring/lib/enum/group-type.mjs"
import { DialogBox } from "lib/@components/dialogBox"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { MissingGroupAmendsListItem } from "./missing-group-amends-list-item"

export function MissingGroupAmendsDialog({ missingTaskLabels = [], groupType = "" }) {
    return (
        <DialogBox
            title={
                <Box display={"flex"} alignItems={"center"} gap={"20px"} data-cy="missing-group-amends-title">
                    <Iconify icon={"material-symbols:warning"} />
                    <Typography variant="h5">Author notes required</Typography>
                </Box>
            }
            value={true}
            okCaption={"Ok"}
        >
            <Box data-cy="missing-group-amends-dialog">
                <Typography mt={2} data-cy="missing-group-amends-message">
                    {getMissingGroupAmendsMessage(groupType)}
                </Typography>
                <Alert
                    severity="error"
                    icon={<Iconify icon={"material-symbols:cancel"} />}
                    data-cy="missing-group-amends-alert"
                    sx={{
                        alignItems: "center",
                        "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
                        mt: 2.5,
                    }}
                >
                    <Stack>
                        <Typography variant="subtitle1" data-cy="missing-group-amends-alert-title">
                            {getMissingGroupAmendsAlertTitle(groupType)}
                        </Typography>
                        <List
                            data-cy="missing-group-amends-list"
                            sx={{
                                listStyleType: "disc",
                                listStylePosition: "inside",
                                "& .MuiListItem-root": { display: "list-item", p: 0 },
                            }}
                        >
                            <Repeat list={missingTaskLabels} item={<MissingGroupAmendsListItem />} />
                        </List>
                    </Stack>
                </Alert>
            </Box>
        </DialogBox>
    )
}

function getMissingGroupAmendsMessage(groupType = "") {
    if (groupType === GroupType.INTRODUCTION) {
        return "Add author notes for the introduction and notes before applying this group to schedules."
    }

    return "Add author notes for each new task before applying this group to schedules."
}

function getMissingGroupAmendsAlertTitle(groupType = "") {
    if (groupType === GroupType.INTRODUCTION) {
        return "Introduction fields missing author notes"
    }

    return "Tasks missing author notes"
}
